import { default as AttachNominationForm } from './AttachNominationForm'
import { default as CompanyConsult } from './CompanyConsult'
import { default as PrincipalDpoName } from './PrincipalDpoName'
import { default as SubstituteDpoName } from './SubstituteDpoName'

export const StepComponents = [
  CompanyConsult,
  PrincipalDpoName,
  SubstituteDpoName,
  AttachNominationForm,
]
